var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","font-size":"16px"}},[_vm._v(" 您无权访问本页面，如需访问请联系新华财经获取相应权限！ ")])}
var staticRenderFns = []

export { render, staticRenderFns }